import React from "react";
import { Phone } from "lucide-react";
import { BUSINESS } from "../data/business";

// Mobile-only fixed Call-Now bar.
//
// Why a dedicated CSS class instead of pure Tailwind:
//   1. iOS Safari shows/hides the URL bar on scroll. A plain `bottom:0` element
//      jumps around as the visual viewport changes. Forcing the element into
//      its own GPU compositing layer (`translateZ(0)` + `will-change: transform`)
//      stabilises it.
//   2. iPhones with a home indicator have a safe-area inset at the bottom.
//      Without `env(safe-area-inset-bottom)` padding the tap target lands
//      under the home indicator and feels broken.
//   3. Explicit `inset: auto 0 0 0` is more reliable than `bottom:0 left:0 right:0`
//      when ancestors create stacking contexts (e.g. backdrop-filter on the header).
export default function StickyMobileCTA() {
  return (
    <a
      href={BUSINESS.phoneHref}
      className="xl:hidden abc-sticky-cta bg-[#54616E] text-white text-center font-bold flex items-center justify-center gap-2"
      data-testid="sticky-mobile-call"
    >
      <Phone className="w-5 h-5" /> Call Now · {BUSINESS.phone}
    </a>
  );
}
